'use client';

import { useEffect } from 'react';
import { useSession } from 'next-auth/react';

import { useProfile } from '@/hooks/use-profile';
import { AgeConfirmationDialog } from '@/features/fanfic-page/components/age-confirmation-dialog';
import { useAgeConfirmationStore } from '@/features/age-verification/store';

export default function AgeConfirmationDialogWrapper() {
  const { data: session } = useSession();
  const { fetchUserData } = useProfile();
  const { isOpen, isConfirming, confirmAge, declineAge, syncLocalConfirmation } =
    useAgeConfirmationStore();

  const isAuthenticated = !!session;

  useEffect(() => {
    syncLocalConfirmation();
  }, [syncLocalConfirmation]);

  const handleConfirm = async () => {
    await confirmAge(isAuthenticated, () => {
      if (isAuthenticated) {
        fetchUserData();
      }
    });
  };

  return (
    <AgeConfirmationDialog
      isOpen={isOpen}
      isConfirming={isConfirming}
      onConfirm={handleConfirm}
      onDecline={declineAge}
    />
  );
}
